import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient();

window.finderTable = window.finderTable || {};
window.finderTable.init = ()=>{
  document.querySelectorAll(".finderTable:not(.ft-loaded)").forEach((el) => {
    const id = el.getAttribute("id");
    el.classList.add("ft-loaded");
    let root;
    if (window.finderTable[id].insertPath) {
      root = ReactDOM.createRoot(
        el.querySelector(window.finderTable[id].insertPath)
      );
    } else {
      root = ReactDOM.createRoot(el);
    }
    root.render(
      <QueryClientProvider client={queryClient}>
        <App id={id} config={window.finderTable[id]} />
      </QueryClientProvider>
    );
  });
};

window.finderTable.init();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
